import { render, staticRenderFns } from "./InvestorOnboardingUpdatePage.vue?vue&type=template&id=d9a68606&"
import script from "./InvestorOnboardingUpdatePage.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingUpdatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports